import { Outlet } from "react-router-dom";

export default function DealerLayout() {
  return (
    <div className="mx-auto min-w-[390px] max-w-[540px]">
      <Outlet />
    </div>
  );
}
